import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CreatorContentMonitorPane } from "src/app/components/CreatorContentMonitorPane/CreatorContentMonitorPane";
import MessageHistoryPreview from "../../components/MessageHistoryPreview/MessageHistoryPreview";
import CreatorMessagePane from "../../components/CreatorMessagePane/CreatorMessagePane";
import { GlobalTaskDetails } from "src/app/components/GlobalTaskDetails/GlobalTaskDetails";
import { useQuery } from "src/app/methods/useQuery";
import DictionaryDetails from "src/app/components/DictionaryDetails/DictionaryDetails";
import { isStringUuid } from "src/utils/methods";
import { RootState } from "src/redux/reducers";
import { setMessageHistoryPreviewOpen } from "src/redux";
import ContentGuidelinesPane from "./ContentGuideLinesPane/ContentGuidelinesPane";

export default function TaskTablePanes() {
  const dispatch = useDispatch();
  const query = useQuery();
  const showGlobalTask = isStringUuid(query.get("displayGlobalTask"));

  const showDiscoveryDetails = isStringUuid(
    query.get("displayDictionaryPreview") || "",
  );
  const showCreatorContentMonitorPane = isStringUuid(
    query.get("creatorContentMonitorUuid") || "",
  );

  const isMessageHistoryPreviewOpen = useSelector(
    (state: RootState) => state.projectReducer.isMessageHistoryPreviewOpen,
  );

  const isCreatorMessagePaneOpen = useSelector(
    (state: RootState) => state.projectReducer.isCreatorMessagePaneOpen,
  );

  const isOpenContentGuidelinesPane = useSelector(
    (state: RootState) => state.projectReducer.isOpenContentGuidelinesPane,
  );

  return (
    <>
      {showCreatorContentMonitorPane && <CreatorContentMonitorPane />}
      {isCreatorMessagePaneOpen && <CreatorMessagePane />}
      {showGlobalTask && <GlobalTaskDetails />}
      {showDiscoveryDetails && <DictionaryDetails />}
      {isMessageHistoryPreviewOpen && (
        <MessageHistoryPreview
          handleClose={() => dispatch(setMessageHistoryPreviewOpen(false))}
        />
      )}
      {isOpenContentGuidelinesPane && <ContentGuidelinesPane />}
    </>
  );
}
